import React, { useState } from 'react';
import { useQueryBuilderOverlay } from '../context/QueryBuilderOverlayContext';
import OverlayTemplate from './common/OverlayTemplate';
import QueryBuilderContent from './query/QueryBuilderContent';

const QueryBuilderOverlay = () => {
  const { isOpen, isMinimized, toggleMinimized, initialQuery } = useQueryBuilderOverlay();
  const [queryMode, setQueryMode] = useState('astroql');
  const [resultFormat, setResultFormat] = useState('csv');
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const icon = (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
  );

  const headerActions = (
    <>
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
        className="p-2 rounded-md hover:bg-ui-light-hover dark:hover:bg-ui-dark-hover transition-colors"
        title={sidebarOpen ? "Hide database explorer" : "Show database explorer"}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-ui-light-text-tertiary dark:text-ui-dark-text-tertiary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      <div className="flex items-center space-x-2">
        <label htmlFor="overlayQueryModeSelect" className="text-sm text-ui-light-text-secondary dark:text-ui-dark-text-secondary">
          Mode:
        </label>
        <select
          id="overlayQueryModeSelect"
          value={queryMode}
          onChange={(e) => setQueryMode(e.target.value)}
          className="text-sm border border-ui-light-border dark:border-ui-dark-border rounded-lg px-2 py-1 text-ui-light-text-primary dark:text-ui-dark-text-primary bg-ui-light-background dark:bg-ui-dark-hover focus:outline-none focus:ring-2 focus:ring-primary-500 transition-colors"
        >
          <option value="astroql">astroql</option>
          <option value="adql">ADQL</option>
          <option value="sql">SQL</option>
        </select>
      </div>

      <div className="flex items-center space-x-2">
        <label htmlFor="overlayResultFormatSelect" className="text-sm text-ui-light-text-secondary dark:text-ui-dark-text-secondary">
          Format:
        </label>
        <select
          id="overlayResultFormatSelect"
          value={resultFormat}
          onChange={(e) => setResultFormat(e.target.value)}
          className="text-sm border border-ui-light-border dark:border-ui-dark-border rounded-lg px-2 py-1 text-ui-light-text-primary dark:text-ui-dark-text-primary bg-ui-light-background dark:bg-ui-dark-hover focus:outline-none focus:ring-2 focus:ring-primary-500 transition-colors"
        >
          <option value="csv">CSV</option>
          <option value="parquet">Parquet</option>
          <option value="fits">FITS</option>
        </select>
      </div>
    </>
  );

  return (
    <OverlayTemplate
      isOpen={isOpen}
      isMinimized={isMinimized}
      onClose={toggleMinimized}
      onToggleMinimize={toggleMinimized}
      icon={icon}
      minimizedTabText="Query"
      width="600px"
      headerActions={headerActions}
      zIndex={54}
      minimizedTabPosition="65%"
    >
      <div className="p-6">
        <QueryBuilderContent
          initialQuery={initialQuery}
          queryMode={queryMode}
          resultFormat={resultFormat}
          sidebarOpen={sidebarOpen}
          showTitle={true}
          vertical={true}
          resultsId="overlay-query-results"
        />
      </div>
    </OverlayTemplate>
  );
};

export default QueryBuilderOverlay;
